import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

// A disabled Material UI button does not receive hover events. Keep its
// explanation on a wrapper so it remains available with a mouse or touch.
export function ActionButton({ component: Component = Button, title = '', ...props }) {
  return (
    <Tooltip title={title} enterTouchDelay={0} leaveTouchDelay={3000}>
      <span style={{ display: 'inline-flex' }}>
        <Component {...props} title={title} />
      </span>
    </Tooltip>
  );
}
